
<div class="profile-content px-0 py-3 m-0">
  <ul class="nav nav-tabs review-nav mb-4 justify-content-center">
    <li class="nav-item">
      <button class="nav-link" [ngClass]="{ active: this.activeTab == 'trendingReview' }"
        (click)="changeFeatureTrending('Trending Review')">
        Trending Conversations
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [ngClass]="{ active: this.activeTab == 'featureReview' }"
        (click)="changeFeatureTrending('Feature Review')">
        Find your representative
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" [ngClass]="{ active: this.activeTab == 'election' }" (click)="displayElections()">
        Elections
      </button>
    </li>
  </ul>
  <div class="container p-0 py-3 px-sm-2 p-md-4 scrollbar-adjust profile-container position-relative">
    <div class="row m-0">
      <div class="col-md-12 text-center">
        <div class="col-12 mb-2">
          <h2 *ngIf="this.activeTab == 'featureReview'">
            Find your representative
          </h2>
          <!-- <h2 *ngIf="this.activeTab == 'trendingReview'">
            Trending Conversations
          </h2> -->
          <div class="" *ngIf="this.activeTab == 'trendingReview'">
            <h2>
              Trending Conversations
            </h2>
            <ul class="nav nav-tabs review-nav my-3 justify-content-center" *ngIf="user != null">
              <li class="nav-item">
                <button class="nav-link font-14" [ngClass]="{ active: trendingReviewActive == 'ALL' }"
                  (click)="getTrendingReviewsByLevel('ALL')">
                  All
                </button>
              </li>
              <li class="nav-item">
                <button type="button" class="nav-link font-14" [ngClass]="{ active: trendingReviewActive == 'MY AREA' }"
                  (click)="getTrendingReviewsByLevel('MY AREA')">
                My Area
                </button>
              </li>
            </ul>
          </div>
          <h2 *ngIf="this.activeTab == 'election'">
            Elections
          </h2>
        </div>
        <form class="col-md-7 p-0 mx-auto my-4" id="searchFormid" *ngIf="this.activeTab == 'election' || this.activeTab == 'featureReview'">
          <div class="col-12 mx-auto px-2 d-flex reprentative-search-custom">
            <div class="ng-autocomplete">
              <input class="search-input" (onAutocompleteSelected)="onAutocompleteSelected($event)"
                (keyup.enter)="searchLocationByName(searchstring)" name="searchstring" id="searchstring"
                [(ngModel)]="searchstring" [placeholder]="getPlaceholderText()" #searchString  />
              <div class="d-flex align-items-center divider my-2" *ngIf="this.activeTab == 'election'">
                <p class="text-center mx-2">
                  or
                </p>
              </div>
              <select class="form-select map-select-input" aria-label="Default select example"
                [(ngModel)]="selectedState" *ngIf="this.activeTab == 'election'" (change)="searchStateByName(selectedState);searchstring = '';fetchElectionDates()" [ngModelOptions]="{ standalone: true }">
                <option value="" disabled selected>
                  Search elections or offices by state
                </option>
                <option *ngFor="let state of statesList" value="{{ state.isoCode }}">
                  {{ state.stateName }}
                </option>
              </select>
            </div>
          </div>
        </form>
        <form>
          <map-view #mapView [latitude]="lat" [longitude]="lng" [zoom]="zoom" *ngIf="this.activeTab == 'election' || this.activeTab == 'featureReview'"
            style="height: 400px; width: 100%">
            <map-marker [latitude]="lat" [longitude]="lng"></map-marker>
          </map-view>
        </form>
        <div class="row mt-3" *ngIf="this.activeTab == 'featureReview'">
          <ul class="nav nav-tabs review-nav mx-auto">
            <li *ngIf="localList.length !== 0" class="nav-item">
              <button class="nav-link" [ngClass]="{ active: locationListActive == 'LOCAL' }"
                (click)="getLocationLists('LOCAL')">
                LOCAL
              </button>
            </li>
            <li *ngIf="stateList.length !== 0" class="nav-item">
              <button class="nav-link" [ngClass]="{ active: locationListActive == 'STATE' }"
                (click)="getLocationLists('STATE')">
                STATE
              </button>
            </li>
            <li *ngIf="countryList.length !== 0" class="nav-item">
              <button class="nav-link" [ngClass]="{ active: locationListActive == 'NATIONAL' }"
                (click)="getLocationLists('NATIONAL')">
                NATIONAL
              </button>
            </li>
          </ul>
        </div>
        <h3 *ngIf="checkRepresentative === false && this.activeTab == 'featureReview'">
          Sorry, There are no representatives in this location.
        </h3>
        <div *ngIf="locationList.length !== 0 && this.activeTab == 'featureReview'" class="row mt-3 px-1 mx-0 location-list" id="Featurereview">
          <div class="col-12 col-md-6 col-lg-4 px-2 py-2" *ngFor="let loc of locationList">
            <button (click)="checkProfile(loc)" class="btn-card location-btn row mx-0">
              <div class="col-auto px-0 my-auto">
                <div *ngIf="loc.photoUrl == '' || loc.photoUrl == null" class="col-auto px-0 my-auto">
                  <ngx-avatars size="7rem" initialsSize="2" [style]="avtarStyle" [round]="false"
                    name="{{ loc.name }}"></ngx-avatars>
                </div>
                <div *ngIf="loc.photoUrl != '' && loc.photoUrl != null" class="col-auto px-0 my-auto">
                  <img *ngIf="loc.photoUrl != '' && loc.photoUrl != null" [src]="loc.photoUrl" alt="Image"
                    onerror="this.src='../../../assets/images/noprofile2.png';" class="img-fluid" />
                </div>
              </div>
              <div class="col text-left p-2">
                <p class="font-14 fw-600">
                  {{ loc.name }}
                </p>
                <p class="font-14">
                  {{ "@" + loc.tagname }}
                </p>
                <p class="font-12 text-gray">
                  <i class="fi flaticon-offic-beg"></i>
                  &nbsp;&nbsp;{{ loc.officename }}
                </p>
                <p class="font-12 text-gray">
                  <i class="fi flaticon-maps-and-flags-1"></i>
                  &nbsp;&nbsp;{{ loc.divisionname }}
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
      <ng-container *ngIf="this.activeTab == 'trendingReview'">
        <div *ngIf="!search && !notFound" class="col-12 mx-auto p-0 trending-reviews mt-3 text-left py-2">
          <div>
            <div class="scroll" (scroll)="onScroll($event)">
              <div class="row mb-2 px-1 d-flex mx-0" id="reviewDiv" [style.height]="reviewDivHeight" [ngClass]="{'no-trending-review-text': trendingReviewList == null}">
                <div class="col-12 d-flex mb-2">
                  <img src="../../../assets/images/star-img.svg" class="star-img">
                  <p class="font-14 fw-500 ml-2">The author has restricted replies to their constituents exclusively</p>
                </div>
                <h3 *ngIf="trendingReviewList === null"
                  class="col-12 text-center mt-3 d-flex align-items-center justify-content-center">
                  &nbsp; No trending conversations at the moment.
                </h3>
                <div class="col-sm-6 col-xl-4 col-xs-12 px-2 py-2" *ngFor="let review of trendingReviewList">
                  <a class="btn btn-card tranding-review p-3 w-100 h-100 position-relative br-10 bg-light-gray"
                    (click)="redirectToResponsePage(review.id)">
                    <div class="loading br-10" [hidden]="trendingReviewLoading"></div>
                      <div class="row">
                        <div class="col-auto pr-2 mb-1">
                          <a [routerLink]="['/profile/view-profile/',review.byProfileTagName]" (click)="$event.stopPropagation()" class="btn btn-img-circle fix-avtar-3">
                            <img *ngIf="review.byProfileImage == '' || review.byProfileImage == null" src="../../../assets/images/noprofile2.png" alt="Profile Image" />
                            <img *ngIf="
                            review.byProfileImage != '' &&
                            review.byProfileImage != null
                            " [src]="review.byProfileImage" onerror="this.src='../../../assets/images/noprofile2.png';"
                                alt="Page Image" />
                          </a>
                        </div>
                        <div class="col pl-0 mb-1 text-left">
                          <a class="btn btn-link btn-link-theme p-0 text-left"
                            [routerLink]="['/profile/view-profile',review.byProfileTagName]"
                            (click)="$event.stopPropagation()">
                            <h6 class="text-theme">
                              {{ review.byProfilePublicName }}
                              <i class="fi flaticon-success font-success font-14 mx-2"></i>
                              <span class="font-12 font-gray">
                                {{ review.daysAgo }}
                              </span>
                            </h6>
                            <p class="font-12 font-gray">
                              {{ "@" + review.byProfileTagName }}
                            </p>
                          </a>
                        </div>
                        <div class="col-auto p-0">
                          <img src="../../../assets/images/star-img.svg" class="star-img" *ngIf="review.isConstituentsOnlyReply">
                          <img src="../../../assets/images/Share_img.svg" class="share-img mx-2" (click)="openShareModal($event,review.id)" />
                        </div>
                      </div>
                      <div class="review-details" *ngIf="review.pollDTO == null">
                        <div class="col-12 p-0">
                          <h5 class="fw-700 text-left review-subject-text">
                            {{ review.subject.length > 63 ? review.subject.substring(0, 63) + "..."
                            : review.subject }}
                          </h5>
                        </div>
                        <div class="col-12 p-0 text-justify mt-2 description-text">
                          <p class="fw-500 text-left review-description-text linkify-html" [innerHTML]="
                            review.content
                              | applinkifyHtml : { limit: true, limitChars: 80 }" (click)="$event.stopPropagation()">
                          </p>
                        </div>
                      </div>
                        <!-------------Questions-Start-------------->
                        <div class="review-details-question text-left" style="height: 130px;overflow-y: auto !important;
                            scrollbar-width: none !important;" *ngIf="review.pollDTO != null">
                          <p class="fw-700 font-14 linkify-html"
                            [innerHTML]="review.pollDTO.question | applinkifyHtml: { limit: true, limitChars: 40 }">
                            <!-- {{ review.pollDTO.question ? (review.pollDTO.question | slice:0:80) + (review.pollDTO.question.length > 80 ? '...' : '')
                                                      : '' }} -->
                          </p>
                          <div class="col-12 px-1 mt-0 form-group">
                            <div class="d-flex justify-content-between">
                              <label class="font-12 fw-400 mb-1 mt-2 pt-1">
                                {{ review.pollDTO.options[0].optionText ? (review.pollDTO.options[0].optionText | slice:0:30) + (review.pollDTO.options[0].optionText.length > 30 ? '...' : '') : '' }}
                              </label>
                              <label class="font-12 fw-400 mb-1 mt-2 pt-1">
                                {{review.pollDTO.options[0].votes }} ({{ ((review.pollDTO.options[0].votes/ review.totalVotes) * 100) | number:'1.1-1'
                                }}%)
                              </label>
                            </div>
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="review.pollDTO.options[0].votes" aria-valuemin="0"
                                [attr.aria-valuemax]="review.totalVotes" [style.width.%]="( review.pollDTO.options[0].votes/ review.totalVotes) * 100"></div>
                            </div>
                            <div class="d-flex justify-content-between">
                              <label class="font-12 fw-400 mb-1 mt-2 pt-1">
                                {{ review.pollDTO.options[1].optionText ? (review.pollDTO.options[1].optionText | slice:0:30) + (review.pollDTO.options[1].optionText.length > 30 ? '...' : '') : '' }}
                              </label>
                              <label class="font-12 fw-400 mb-1 mt-2 pt-1">
                                {{ review.pollDTO.options[1].votes }} ({{ ((review.pollDTO.options[1].votes / review.totalVotes) * 100) | number:'1.1-1'
                                }}%)
                              </label>
                            </div>
                            <div class="progress">
                              <div class="progress-bar" role="progressbar" [attr.aria-valuenow]="review.pollDTO.options[1].votes" aria-valuemin="0"
                                [attr.aria-valuemax]="review.totalVotes" [style.width.%]="( review.pollDTO.options[1].votes/ review.totalVotes) * 100"></div>
                            </div>
                            <div class="text-right mt-1" *ngIf="review.pollDTO.options.length > 2">
                              <a class="btn btn-link btn-link-theme pr-0" [routerLink]="['/profile/view-response', review.id]" (click)="$event.stopPropagation()">See More</a>
                            </div>
                          </div>
                        </div>
                      <!-------------Questions-End-------------->
                    <div class="col-12 d-flex p-0 mt-3">
                      <div class="text-left p-0 d-flex align-items-center" [ngClass]="review.pollDTO !== null ? 'col-6': ['col-xl-auto','col-3']">
                        <p class="text-gray">
                          {{ review.createdDate | date : "mediumDate" }}
                        </p>
                      </div>
                      <div class="col-xl-auto col-3 d-flex align-items-center px-0" *ngIf="review.pollDTO == null">
                        <i class="fi flaticon-comment iconposition ml-4"></i>
                        <span>
                          &nbsp; {{ review.responseCount }} &nbsp;
                        </span>
                      </div>
                      <div class="col-6 p-0 text-right">
                        <button type="button" class="btn btn-outline-black"
                         (click)="redirectPage(review.id); $event.stopPropagation()">
                          Join Conversation
                        </button>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- .trending-reviews -->
        <div class="row mx-md-auto mx-sm-3 mx-0 mt-3 flex-lg-row fix-height-240px flex-md-column-reverse flex-column-reverse" *ngIf="notFound && search && searchValue !== null">
          <div class="m-auto text-center position-relative">
            <h1>
              Sorry, we couldn't find any matching profile
            </h1>
          </div>
        </div>
      </ng-container>
      <!-- election start-->
      <div *ngIf="this.activeTab == 'election'" class="col-12">
        <div *ngIf="!search && !notFound" class="col-12 mx-auto p-0 trending-reviews mt-3 text-left py-2">
          <div class="row mx-0 px-2 mt-2">
            <ul class="nav nav-tabs review-nav mx-auto">
              <li class="nav-item">
                <button class="nav-link active">
                  List of Elections
                </button>
              </li>
            </ul>
          </div>
        </div>
        <ng-container *ngIf="this.activeTab == 'election'">
          <div class="col-12 d-flex election-list-div my-3" *ngFor="let election of electionDates; let i = index" id="electionList">
            <h2 class="mb-0 col-11 d-sm-flex align-items-center election-list-card" (click)="redirectToElectionDetailPage(election)">
              <h5 class="text-left fw-600 text-color col-sm-auto col-12 p-sm-0">
                &nbsp;{{ formatDate(election.electionDate) }} |
              </h5>
              <h5 class="text-left fw-600 text-color col-sm-auto col-12 p-sm-0 my-sm-0 my-2">
                &nbsp;{{ election.day }} |
              </h5>
              <h5 class="fw-600 col-sm-auto col-12 p-sm-0">
                &nbsp;{{ election.daysLeft }} Days
              </h5>
            </h2>
            <div class="col-1 p-0 d-flex justify-content-end election-list-img">
              <img src="../../../assets/images/arrow.png" (click)="redirectToElectionDetailPage(election)" />
            </div>
          </div>
        </ng-container>
      </div>
      <!--election end-->
      <!-- No election found start -->
      <div class="col-12 text-center my-5 py-5" *ngIf="this.activeTab == 'election' && this.electionDates.length == 0">
        <img src="/assets/images/no-waiting.svg" class="no-data-img" />
        <h6 class="mt-2">
          No Election List Found !
        </h6>
      </div>
    </div>
  </div>
</div>
<!-- .homepage-content -->
<!-- Restriction Modal -->
<div class="modal fade" id="restrictResponseModals" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <i class="fi flaticon-information font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          You must have your own page on CitizeX to add a response.
        </p>
        <div class="col-12 text-center">
          <button [routerLink]="['/profile/search-profile']" class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12"
            data-dismiss="modal">
            Create your page
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!---------------------claim-request------------------>
<div class="modal fade" id="restrictUnclaimedProfileResponseModals" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h1 class="text-center theme-color">
          <i class="fi flaticon-information font-40"></i>
        </h1>
        <h6 class="text-center bold my-3 theme-color">Sorry !</h6>
        <p class="text-center theme-color">
          Your claim request is currently under review. You will be notified
          within 24 to 48 hours. Until your request is approved, you won't be
          able to add a response.
        </p>
        <div class="col-12 text-center">
          <button class="btn btn-outline-black mt-4 mb-2 mx-2 py-1 font-12" data-dismiss="modal">
            ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- share model-->
<div class="modal fade" id="shareModal" tabindex="-1" role="dialog" aria-labelledby="uniqueshareModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header py-3 px-4">
        <h5 class="modal-title fw-700" id="uniqueshareModal">
          Share
        </h5>
        <button type="button" class="close modal-close-button font-32 mt-2" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div class="modal-body modal-confirm mt-2">
        <div class="text-center mb-4">
          <share-buttons [theme]="'circles-dark'" [include]="[
          'facebook',
          'twitter',
          'linkedin',
          'pinterest',
          'reddit',
          'mix',
          'vk',
          'tumblr',
          'telegram',
          'whatsapp',
          'sms',
          'email'
          ]" [url]="currentUrl" [showText]="true">
          </share-buttons>
        </div>
        <div class="input-group col-12 copy-input-group px-0">
          <input type="text" class="form-control" [value]="currentUrl" #copyLink readonly />
          <div class="input-group-prepend">
            <div class="input-group-text">
              <button value="click to copy" class="btn btn-black" (click)="copyToClipboard(copyLink)">
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- share model-->
<!-- conversation error model start -->
<div class="modal conversationErrorModal" id="conversationErrorModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title theme-color fw-600 font-20">Error</h3>
        <button type="button" class="close mt-2 font-32 pr-md-3 pr-0" aria-label="Close" data-dismiss="modal" >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
           <p class="font-16 theme-color fw-500 text-left">
            Based on the ID you provided during verification, it appears you are not one of the author's constituents eligible to participate in this conversation.</p>
            <p class="mb-2 mt-1 font-16 theme-color fw-500 text-left">
              If you believe this is an error, please <a class="fw-700 alert-modal-text" (click)="verifymodal()">update your
                address</a> by submitting a new verification using an ID that reflects your current address. Alternatively, you can
              submit a support ticket <a class="fw-700 alert-modal-text" (click)="feedbackmodal()">here</a></p>
            <div class="col-12 text-right px-0">
              <button type="submit" class="btn btn-black my-2 font-16 fw-400" data-dismiss="modal">
                OK
              </button>
            </div>
      </div>    
    </div>  
  </div>   
</div>
<!-- conversation error model end -->
<!-- conversation Alert model start -->
  <div class="modal conversationAlertModal" id="conversationAlertModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title theme-color fw-600 font-20">Alert</h3>
          <button type="button" class="close mt-2 font-32 pr-md-3 pr-0" aria-label="Close" data-dismiss="modal" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
             <p class="font-16 theme-color fw-500 text-left">
              Only this author's constituents are eligible to participate in this conversation.</p>
              <p class="mb-2 mt-1 theme-color font-16 fw-500 text-left">
              If you believe you are eligible, please complete your verification <a class="fw-700 alert-modal-text" (click)="verifymodal()">here</a> by providing an ID that includes your address.</p> 
              <div class="col-12 text-right px-0">
                <button type="submit" class="btn btn-black my-2 font-16 fw-400" data-dismiss="modal">
                  OK
                </button>
              </div>
        </div>
      </div>
    </div>
  </div>
<!-- conversation Alert model end -->
<!---------------------verify-Modal----------------->
<div id="veriffModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="phoneNumberModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-custom modal-theme" role="document">
    <div class="modal-content">
      <div class="modal-body p-5">
        <button aria-label="Close" class="close close-modal" data-dismiss="modal" type="button">
          <span class="fi flaticon-cancel"></span>
        </button>
        <h3 class="text-center">Veriff Verification</h3>
        <div id="veriff-root"></div>
      </div>
    </div>
  </div>
</div>
<!----------------congratsModal-------------------->
<div class="modal fade" id="congratsModal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-2 mb-2">Congratulations! search</h5>
        <button type="button" class="close mt-2 font-32" aria-label="Close" data-dismiss="modal">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-justify theme-color mb-2">
          Congratulations! You have completed the first milestone towards your
          CitizeX profile creation.
        </p>
        <div class="col-12 text-center">
          <button class="btn btn-black mt-4 mb-2 mx-2 py-2 px-sm-2 px-3 font-14">
            Next
          </button>
        </div>
      </div>
      <!-- .modal-body -->
    </div>
    <!-- .modal-content -->
  </div>
  <!-- .modal-dialog -->
</div>
<!----------------Feed-back-Modal------------------------->
<div class="modal fade havefeedbackmodal" tabindex="-1" role="dialog" id="FeedbackModal" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-20 fw-600">Have Feedback?</h5>
        <button type="button" class="close" aria-label="Close" data-dismiss="modal" (click)="resetFormData(feedbackForm)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #feedbackForm="ngForm" (ngSubmit)="sendBugReportOrFeedback(feedbackForm)" novalidate>
          <div class="form-group d-flex aling-items-center radio-btn-group">
            <label class="d-flex align-items-center font-18 fw-600 mb-0">Report a bug
              <input type="radio" name="feedback" value="report a bug" [(ngModel)]="reportBugFeedbackDTO.type" class="ml-3" required
                #type="ngModel" /></label>
            <label class="d-flex align-items-center font-18 fw-600 mb-0">Feedback
              <input type="radio" name="feedback" value="feedback" [(ngModel)]="reportBugFeedbackDTO.type" class="ml-3" required
                #type="ngModel" />
            </label>
          </div>
          <div *ngIf="feedbackForm.submitted && type.invalid" class="text-danger mb-2 text-center">
            Please select a feedback type.
          </div>
          <div class="form-group">
            <label for="description" class="font-16 fw-600">Description</label>
            <textarea id="description" class="form-control" rows="5" [(ngModel)]="reportBugFeedbackDTO.description"
              name="description" required maxlength="1000" #description="ngModel" NoLeadingWhitespace></textarea>
            <div *ngIf="feedbackForm.submitted && description.invalid" class="text-danger">
              <span *ngIf="description.errors?.['required']">Description is required.</span>
              <span *ngIf="description.errors?.['maxlength']">You've reached the maximum limit of 1000
                characters.</span>
            </div>
          </div>
          <div class="d-flex justify-content-end mr-4">
            <button type="button" class="btn btn-outline-black mt-4 pt-2 mb-3 mx-2 font-16 fw-600" data-dismiss="modal"
              (click)="resetFormData(feedbackForm)">
              Cancel
            </button>
            <button type="submit" class="btn btn-black mt-4 pt-2 mb-3 mx-2 font-16 fw-600">
              Report
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<!-- feed back modal ends-->
<div class="modal fade" id="verificationErrorModel" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered conversation-Modal" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title fw-700 font-18" id="exampleModalLongTitle">Error</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mt-2" *ngIf="veriffStatus == 'rejection'">
          <span style="font-size: 14px" class="verified">
            <!-- Your request has been rejected due to mismatch in ID, if you wish to update your user information -->
            Your request has been rejected due to a mismatch in ID.
            <!-- To update your user information, please click here and try again.
            <a style="color: #161616;" data-dismiss="modal" [routerLink]="['/edit-user']"><u class="fw-700"
                style="text-decoration: none;">Click
                here</u></a>
            and retry. -->
          </span>
          <p class="font-13 fw-600 mt-2">Possible reasons for the rejection include:</p>
          <div class="col mt-1 pl-4 mb-2">
            <ul class="ul-style">
              <li class="list-symbol">Missing middle name in the 'first and middle name' field during sign-up.</li>
              <li class="list-symbol">The name entered at sign-up does not match the name on your ID.</li>
              <li class="list-symbol">An extra space after your last name.</li>
            </ul>
          </div>
        </div>
        <div *ngIf="veriffStatus == 'declined'">
          <span style="font-size: 15px" class="verified">
            Your request has been declined , please retry.</span>
        </div>
        <div class="col-12 text-center mt-3">
          <button type="button" class="btn btn-black font-14" data-dismiss="modal">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Update address Model  -->
<div class="modal fade" id="AddressUpdateModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-custom modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
        <p class="font-16 fw-600">Address Updated</p>
        <div class="col-12 text-center mt-4 mb-2 mx-2">
          <button type="button" class="btn btn-outline-black font-16 fw-400" data-dismiss="modal">
            Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>